module.exports = __webpack_public_path__ + "static/media/BH-Grim-Gold.635cf738.png";